const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Bonuses are granted to participating companies based on submitted sales figures.",
};

export default {
  messages,
};
